import React from 'react';
import Logger from 'observability/Logger';

const LOG = new Logger('FormIdContext');

export const FormIdContext = React.createContext('formId');

export const withFormId = (OriginalComponent) => (props) =>
    (
        <FormIdContext.Consumer>
            {(formId) => {
                if (!formId) {
                    LOG.error('[form-renderer] No formId provided');
                }
                return <OriginalComponent {...props} formId={formId} />;
            }}
        </FormIdContext.Consumer>
    );
